export default __webpack_public_path__ + "static/media/back-btn-vector.7026f807.svg";